import { isNumber } from '../assertion'

export const ariaAttr = condition => (condition ? true : null)

export function getRelatedTarget(event) {
  const target = event.target ?? event.currentTarget
  const activeElement = document.activeElement
  return event.relatedTarget ?? activeElement
}

export function contains(parent, child) {
  if (!parent) return false

  return parent === child || parent.contains(child)
}

export function mergeClassnames(...classnames) {
  return classnames.filter(Boolean).join(' ')
}


export function getStringWidth(
  value = '',
  {
    fontSize = 15,
    lineHeight = null,
    letterSpacing = null,
    padding = 0,
    ...rest
  }
) {
  const div = document.createElement('div')
  div.innerText = value

  const _fontSize = isNumber(fontSize) ? `${fontSize}px` : fontSize
  const _lineHeight = isNumber(lineHeight) ? `${lineHeight}px` : lineHeight
  const _letterSpacing = isNumber(letterSpacing)
    ? `${letterSpacing}px`
    : letterSpacing
  const _padding = isNumber(padding) ? `0 ${padding}px` : `0 ${padding}`

  Object.assign(div.style, {
    fontSize: _fontSize,
    lineHeight: _lineHeight,
    letterSpacing: _letterSpacing,
    padding: _padding,
    width: 'auto',
    display: 'inline-block',
    visibility: 'hidden',
    position: 'fixed',
    overflow: 'auto',
    boxSizing: 'border-box',
    ...rest
  })

  document.body.append(div)
  const width = div.clientWidth
  div.remove()

  return width
}
